var btnCircle = {
  "btnCircle": {
    "borderRadius": "100%",
    "padding": "0.6875rem"
  }
};

export { btnCircle as default };
